(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magdor-privacy-legal"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('magdor-privacy-legal'))customElements.define('magdor-privacy-legal',class extends HTMLElement{
connectedCallback(){
if(this.hasAttribute('data-enhanced'))return;
const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')],nav=this.querySelector('.mglegal-tabs');
if(!tabs.length||tabs.length!==panels.length||!nav)return;
const mobile=()=>matchMedia('(max-width:600px)').matches;
const orientation=()=>nav.setAttribute('aria-orientation',mobile()?'horizontal':'vertical');
orientation();
const faqContent=this.querySelector('[data-faq-content]'),faqStatus=this.querySelector('[data-faq-status]'),faqFallback=this.querySelector('[data-faq-fallback]');
let faqRequest;
const loadFaq=()=>{
if(!faqContent||faqRequest)return;
faqContent.setAttribute('aria-busy','true');
faqRequest=(async()=>{
try{
const response=await fetch(faqContent.dataset.faqUrl,{credentials:'same-origin'});
if(!response.ok)throw new Error('FAQ unavailable');
const source=new DOMParser().parseFromString(await response.text(),'text/html');
const items=[...source.querySelectorAll('main .faq__heading-title,main .faq__details')];
if(!items.some(item=>item.matches('.faq__details')))throw new Error('FAQ questions unavailable');
const fragment=document.createDocumentFragment();
items.forEach(item=>{
if(item.matches('.faq__heading-title')){
const heading=document.createElement('h3');heading.className='mglegal-faq-heading';heading.textContent=item.textContent;fragment.append(heading);return;
}
const question=item.querySelector('summary'),answer=item.querySelector('.faq__answer');
if(!question||!answer)throw new Error('FAQ answer unavailable');
const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
summary.textContent=question.textContent.trim();body.className='mglegal-copy';
[...answer.childNodes].forEach(node=>body.append(document.importNode(node,true)));
details.append(summary,body);fragment.append(details);
});
faqContent.replaceChildren(fragment);faqStatus.hidden=true;faqFallback.hidden=true;
}catch{
faqStatus.textContent=faqStatus.dataset.faqError;faqStatus.hidden=false;faqFallback.hidden=false;faqRequest=null;
}finally{faqContent.removeAttribute('aria-busy')}
})();
};
const activate=(tab,focus=false)=>{tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1});panels.forEach(p=>p.hidden=p.dataset.panel!==tab.dataset.tab);if(tab.dataset.tab==='faq')loadFaq();if(focus)tab.focus()};
nav.setAttribute('role','tablist');
tabs.forEach((tab,i)=>{
tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panels[i].id);panels[i].setAttribute('role','tabpanel');
tab.addEventListener('click',e=>{e.preventDefault();activate(tab)});
tab.addEventListener('keydown',e=>{let n;const horizontal=mobile();if(e.key===(horizontal?'ArrowRight':'ArrowDown'))n=(i+1)%tabs.length;if(e.key===(horizontal?'ArrowLeft':'ArrowUp'))n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n===undefined)return;e.preventDefault();activate(tabs[n],true)});
});
this.querySelectorAll('.mglegal-content').forEach(content=>{
if(content.closest('[data-panel="returns"]')){
[...content.children].filter(node=>{
if(node.tagName!=='P'||node.children.length!==1)return false;
const label=node.firstElementChild,text=node.textContent.trim();
return /^(STRONG|B)$/.test(label.tagName)&&text===label.textContent.trim()&&text.length>0&&text.length<=120&&!/[.!?]$/.test(text);
}).forEach(label=>{
const heading=document.createElement('h3');
while(label.firstChild)heading.append(label.firstChild);
label.replaceWith(heading);
});
}
[...content.children].filter(n=>/^H[2-4]$/.test(n.tagName)&&n.textContent.trim()).forEach((heading,i)=>{
const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');body.className='mglegal-copy';summary.textContent=heading.textContent;
let sibling=heading.nextSibling;heading.before(details);details.append(summary,body);
while(sibling&&!(sibling.nodeType===1&&/^H[2-4]$/.test(sibling.tagName))){const next=sibling.nextSibling;body.append(sibling);sibling=next}
heading.remove();details.open=i===0;
});
});
const updateSticky=()=>{const header=document.querySelector('.site-header');if(!header)return;const rect=header.getBoundingClientRect();this.style.setProperty('--mglegal-sticky-top',Math.max(35,rect.height+24)+'px')};
updateSticky();
this.onLegalResize=()=>{orientation();updateSticky()};window.addEventListener('resize',this.onLegalResize,{passive:true});
this.setAttribute('data-enhanced','');activate(tabs.find(t=>t.hash===location.hash)||tabs[0]);
const button=this.querySelector('[data-cookies]');
if(button)button.addEventListener('click',async()=>{const status=this.querySelector('[data-status]');status.hidden=true;button.disabled=true;try{if(!window.privacyBanner?.showPreferences)throw new Error('Preferences unavailable');await window.privacyBanner.showPreferences()}catch{status.hidden=false}finally{button.disabled=false}});
}
disconnectedCallback(){if(this.onLegalResize)window.removeEventListener('resize',this.onLegalResize)}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magdor-tennis-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = root => {
  if (root.dataset.initialized === 'true') return;
  const form = root.querySelector('.mtc-toolbar');
  const grid = root.querySelector('.mtc-grid');
  if (!form || !grid) return;
  root.dataset.initialized = 'true';
  const cards = [...grid.querySelectorAll('.mtc-card')];
  const availability = form.elements.namedItem('mtc-availability');
  const origin = form.elements.namedItem('mtc-origin');
  const sort = form.elements.namedItem('mtc-sort');
  const results = root.querySelector('[data-mtc-results]');
  const empty = root.querySelector('[data-mtc-empty]');

  const resets = [...form.querySelectorAll('[type="reset"]')];
  const panel = form.querySelector('.mtc-panel');
  const openButton = form.querySelector('[data-mtc-open]');
  const closeButton = form.querySelector('[data-mtc-close]');
  const applyButton = form.querySelector('[data-mtc-apply]');
  const selection = form.querySelector('[data-mtc-selection]');
  const summary = form.querySelector('[data-mtc-summary]');
  const filterCount = form.querySelector('[data-mtc-filter-count]');
  let previousOverflow = '';
  openButton.addEventListener('click', () => {
   if (panel.open) return;
   previousOverflow = document.documentElement.style.overflow;
   panel.showModal();
   document.documentElement.style.overflow = 'hidden';
   closeButton.focus();
  });
  closeButton.addEventListener('click', () => panel.close());
  applyButton.addEventListener('click', () => panel.close());

  panel.addEventListener('keydown', event => {
   if (event.key !== 'Tab') return;
   const controls = [...panel.querySelectorAll('button,input,select,a[href],[tabindex]')].filter(control => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length);
   const first = controls[0];
   const last = controls[controls.length - 1];
   if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
   else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  panel.addEventListener('click', event => {
   const box = panel.getBoundingClientRect();
   if (event.target === panel && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) panel.close();
  });
  panel.addEventListener('close', () => {
   document.documentElement.style.overflow = previousOverflow;
   openButton.focus();
  });

  const french = document.documentElement.lang.toLowerCase().startsWith('fr');
  const text = french ? {
   from: 'À partir de ', enquiry: 'Prix sur demande', one: 'pièce', many: 'pièces',
   ready: 'En stock', made: 'Sur commande', order: 'Disponible sur commande', unavailable: 'Vérifier la disponibilité'
  } : {
   from: 'From ', enquiry: 'Price upon request', one: 'piece', many: 'pieces',
   ready: 'In stock', made: 'Made to Order', order: 'Available to Order', unavailable: 'Enquire About Availability'
  };
  const groups = new Map(cards.flatMap(card => {
   const template = card.querySelector('[data-mtc-group-members]');
   return template ? [[card, [...template.content.querySelectorAll('[data-member-origin]')]]] : [];
  }));
  const syncGroup = card => {
   const members = groups.get(card);
   if (!members) return origin.value === 'all' || (card.dataset.mtcOrigins || '').split(/\s+/).includes(origin.value);
   const matching = members.filter(member =>
    (origin.value === 'all' || member.dataset.memberOrigin === origin.value) &&
    (availability.value === 'all' || member.dataset.state === availability.value)
   );
   if (!matching.length) return false;
   const priced = matching.filter(member => Number(member.dataset.price) > 0);
   const orderable = priced.filter(member => member.dataset.available === 'true');
   const pool = orderable.length ? orderable : priced.length ? priced : matching;
   const selected = [...pool].sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price))[0];
   const price = Number(selected.dataset.price);
   card.dataset.mtcPrice = String(price);
   card.dataset.mtcState = selected.dataset.state;
   const varies = selected.dataset.priceVaries === 'true' || pool.some(member => Number(member.dataset.price) > price);
   card.querySelector('.mtc-price').textContent = price > 0 ? (varies ? text.from : '') + selected.dataset.priceLabel : text.enquiry;
   card.querySelector('.mtc-state').textContent = text[selected.dataset.state] || text.unavailable;
   const imageLink = card.querySelector('.mtc-image');
   imageLink.setAttribute('aria-label', selected.dataset.label);
   if (card.dataset.mtcMember !== selected.dataset.memberOrigin) {
    imageLink.replaceChildren(selected.querySelector('[data-mtc-member-image]').content.cloneNode(true));
    card.dataset.mtcMember = selected.dataset.memberOrigin;
   }
   card.querySelectorAll('.mtc-image, h2 a, .mtc-action').forEach(link => link.href = selected.dataset.url);
   return true;
  };
  const update = () => {
   const type = form.querySelector('input[type="radio"]:checked').value;
   const matches = new Map(cards.map(card => [card, syncGroup(card)]));
   const ordered = [...cards].sort((a,b) => {
    const first = Number(a.dataset.mtcPrice);
    const second = Number(b.dataset.mtcPrice);
    if (sort.value.startsWith('price-')) {
     if ((first > 0) !== (second > 0)) return first > 0 ? -1 : 1;
     const difference = sort.value === 'price-asc' ? first - second : second - first;
     if (difference) return difference;
    } else if (sort.value === 'title') {
     const difference = a.dataset.mtcTitle.localeCompare(b.dataset.mtcTitle, document.documentElement.lang);
     if (difference) return difference;
    }
    return Number(a.dataset.mtcIndex) - Number(b.dataset.mtcIndex);
   });
   let count = 0;
   ordered.forEach(card => {
    card.hidden = !(matches.get(card) && (availability.value === 'all' || card.dataset.mtcState === availability.value) && (type === 'all' || card.dataset.mtcKind === type));
    if (!card.hidden) count++;
   });
   if (ordered.some((card,index) => grid.children[index] !== card)) grid.append(...ordered);
   results.textContent = count + ' ' + (count === 1 ? text.one : text.many);
   empty.hidden = count !== 0 || cards.length === 0;

   const clear = type === 'all' && availability.value === 'all' && origin.value === 'all' && sort.value === 'featured';
   resets.forEach(button => { button.disabled = clear; button.hidden = clear; });
   const active = [availability.value !== 'all', origin.value !== 'all', sort.value !== 'featured'].filter(Boolean).length;
   filterCount.hidden = active === 0;
   filterCount.textContent = '(' + active + ')';
   selection.hidden = clear;
   const selectedText = [];
   const selectedType = form.querySelector('.mtc-tabs input:checked');
   if (type !== 'all') selectedText.push(selectedType.nextElementSibling.textContent.trim());
   ['mtc-availability','mtc-origin','mtc-sort'].forEach(name => {
    const input = form.querySelector('input[name="' + name + '"]:checked');
    if (input && !['all','featured'].includes(input.value)) selectedText.push(input.nextElementSibling.textContent.trim());
   });
   summary.textContent = selectedText.join(' · ');
   applyButton.textContent = (french ? 'Voir ' : 'Show ') + count + ' ' + (count === 1 ? text.one : text.many);

  };
  form.addEventListener('change', update);
  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('reset', () => setTimeout(() => {
   update();
   if (resets.includes(document.activeElement) && document.activeElement.disabled) { if (panel.open) applyButton.focus(); else form.querySelector('.mtc-tabs input[value="all"]').focus(); }
  }, 0));
  root.querySelector('[data-mtc-reset]').addEventListener('click', () => {
   form.reset();
   form.querySelector('input[value="all"]').focus();
  });
  if (cards.length) form.hidden = false;
  update();
 };
 const initializeWithin = container => {
  if (container.matches && container.matches('.mtc')) initialize(container);
  container.querySelectorAll('.mtc').forEach(initialize);
 };
 if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
 } else {
  initializeWithin(document);
 }
 document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-cart"]) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const pieces = {'15417895911725':'coin','15417897025837':'bar','15414311190829':'name'};
  const words = {
    en: {
      checking:'Checking your personalization…',
      heading:'Please correct or remove the following personalized items before checkout.',
      unavailable:'This configuration is not available to purchase.',
      name:'Enter a name with 1–12 letters. Spaces, hyphens and apostrophes between letters are allowed.',
      characters:'Remove control or invisible characters from the text.',
      limit:'Use no more than {limit} characters.',
      count:'The name must match the letter count of the selected variant.',
      lettering:'Choose a valid lettering style.',
      acknowledgement:'Confirm the personalized-order terms in the configurator.',
      material:'The personalization details must match the selected material and karat.',
      details:'Your personalization details could not be verified. Please select them again.',
      size:'Choose a valid ring size.',
      editRing:'Select your ring size',
      failed:'We could not verify your personalized items. Please try again or reload the page.',
      pending:'Please wait for the quantity update to finish, then try checkout again.',
      edit:'Personalize this necklace'
    },
    fr: {
      checking:'Vérification de votre personnalisation…',
      heading:'Corrigez ou retirez les articles personnalisés suivants avant de passer à la caisse.',
      unavailable:'Cette configuration n’est pas disponible à l’achat.',
      name:'Entrez un prénom de 1 à 12 lettres. Les espaces, traits d’union et apostrophes entre les lettres sont permis.',
      characters:'Retirez les caractères de contrôle ou invisibles du texte.',
      limit:'Utilisez au maximum {limit} caractères.',
      count:'Le prénom doit correspondre au nombre de lettres de la variante choisie.',
      lettering:'Choisissez un style de lettrage valide.',
      acknowledgement:'Confirmez les conditions de commande personnalisée dans le configurateur.',
      material:'Les détails de personnalisation doivent correspondre au métal et au carat choisis.',
      details:'Impossible de vérifier vos détails de personnalisation. Veuillez les sélectionner à nouveau.',
      size:'Choisissez une taille de bague valide.',
      editRing:'Choisir votre taille de bague',
      failed:'Impossible de vérifier vos articles personnalisés. Réessayez ou actualisez la page.',
      pending:'Attendez la fin de la mise à jour des quantités, puis réessayez.',
      edit:'Personnaliser ce collier'
    }
  };
  function parseCartSnapshot(text) {
    const snapshot = JSON.parse(text);
    const decoder = document.createElement('textarea');
    const decode = value => typeof value === 'string'
      ? value.replace(/&(?:#[xX][0-9a-fA-F]+|#[0-9]+|[a-zA-Z][a-zA-Z0-9]+);/g, entity => {
        decoder.innerHTML = entity;
        return decoder.value;
      }) : value;
    if (Array.isArray(snapshot?.items)) {
      for (const item of snapshot.items) {
        const properties = Array.isArray(item.properties)
          ? item.properties : Object.entries(item.properties || {});
        item.properties = properties.map(([key, value]) => [decode(key), decode(value)]);
      }
    }
    return snapshot;
  }
  function errorsFor(item, limits) {
    const piece = pieces[String(item.productId)];
    if (!piece && !item.ringSizeRequired) return [];
    let p;
    try { p = window.MagdorCheckoutProperties.read(item.properties).canonical; }
    catch { return ['details']; }
    if (!piece) {
      if (item.purchasable !== true) return ['unavailable'];
      const sizes = Array.from({length:17}, (_, index) => String(4 + index / 2));
      return sizes.includes(p['Ring size']) ? [] : ['size'];
    }
    const errors = [];
    const value = p[piece === 'name' ? 'Name' : 'Engraving'] ?? '';
    const limit = limits[piece];
    const options = Array.isArray(item.options)
      ? item.options.map(value => window.MagdorCheckoutProperties.canonicalMaterial(value) || value)
      : [];
    if (item.purchasable !== true || !Number.isSafeInteger(item.variantId) || item.variantId < 1) errors.push('unavailable');
    if (typeof value !== 'string' || !Number.isFinite(limit) || limit < 1) return errors.concat('characters');
    if (/[\p{Cc}\p{Cf}\p{Cs}]/u.test(value)) errors.push('characters');
    if (Array.from(value).length > limit) errors.push('limit');
    if (piece === 'name') {
      const count = Array.from(value).filter(ch => /\p{L}/u.test(ch)).length;
      if (count < 1 || count > 12 || !/^[\p{L}\p{M}]+(?:[ '\u2019-][\p{L}\p{M}]+)*$/u.test(value)) errors.push('name');
      if (!Number.isInteger(item.letterCount) || item.letterCount < 1 || item.letterCount > 12 || count !== item.letterCount || p['Letter count'] !== String(item.letterCount)) errors.push('count');
      if (options[0] === '925 Sterling Silver') {
        if (options[1] !== 'N/A' || p.Metal !== options[0] || (p.Karat != null && p.Karat !== '' && p.Karat !== 'N/A')) errors.push('material');
      } else {
        if (!['Yellow Gold','White Gold'].includes(options[0]) || !['14K','18K'].includes(options[1]) || p.Metal !== options[0] || p.Karat !== options[1]) errors.push('material');
      }
    } else {
      const material = options[0];
      if (material === '925 Sterling Silver') {
        if (p.Metal !== material || (p.Karat != null && p.Karat !== '')) errors.push('material');
      } else {
        const match = typeof material === 'string' && /^(14K|18K) (Yellow Gold|White Gold)$/.exec(material);
        if (!match || p.Karat !== match[1] || p.Metal !== match[2]) errors.push('material');
      }
    }
    if (piece === 'name' || value.trim()) {
      if (!['Classic','Modern','Signature'].includes(p.Lettering)) errors.push('lettering');
      if (p['Personalized order acknowledgement'] !== 'Yes' || typeof p['Acknowledgement text'] !== 'string' || !p['Acknowledgement text'].trim()) errors.push('acknowledgement');
    }
    return [...new Set(errors)];
  }
  function init(root) {
    if (controllers.has(root)) return;
    const form = root.querySelector('form');
    const panel = root.querySelector('[data-mp-cart-validation]');
    if (!form || !panel) return;
    const status = panel.querySelector('[data-mp-cart-status]');
    const list = panel.querySelector('[data-mp-cart-errors]');
    const w = words[document.documentElement.lang.split('-')[0]] || words.en;
    let snapshot, busy = false, permitSubmit = false, version = 0, timer, lastBlocked = true;
    try {
      snapshot = parseCartSnapshot(root.querySelector('[data-mp-cart-data]').textContent);
      if (!Array.isArray(snapshot.items)) throw new Error('Invalid cart data');
    } catch {
      panel.hidden = false;
      status.textContent = w.failed;
      root.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
      return;
    }
    const protectedItems = () => snapshot.items.filter(item => pieces[String(item.productId)] || item.ringSizeRequired);
    const buttons = () => [...root.querySelectorAll('[name="checkout"]')];
    function lock(blocked) {
      lastBlocked = blocked;
      buttons().forEach(button => {
        button.disabled = blocked;
        button.setAttribute('aria-disabled', String(blocked));
        button.setAttribute('aria-busy', String(busy));
        button.setAttribute('aria-describedby', 'mp-cart-validation-' + snapshot.sectionId);
      });
      root.querySelectorAll('.additional-checkout-buttons,shopify-accelerated-checkout-cart').forEach(el => {
        el.hidden = protectedItems().length > 0;
      });
    }
    panel.id = 'mp-cart-validation-' + snapshot.sectionId;
    function show(focus = false) {
      const failures = protectedItems().map(item => ({item, errors:errorsFor(item, snapshot.limits)})).filter(entry => entry.errors.length);
      list.replaceChildren();
      status.textContent = w.heading;
      for (const {item, errors} of failures) {
        const li = document.createElement('li');
        const text = document.createElement('span');
        text.textContent = item.title + ': ' + errors.map(code => w[code].replace('{limit}', snapshot.limits[pieces[String(item.productId)]])).join(' ') + ' ';
        const link = document.createElement('a');
        link.href = item.ringSizeRequired && !pieces[String(item.productId)]
          ? item.url : snapshot.personalizationUrl + '?model=' + pieces[String(item.productId)];
        link.textContent = item.ringSizeRequired && !pieces[String(item.productId)] ? w.editRing : w.edit;
        li.append(text, link);
        list.append(li);
      }
      list.hidden = failures.length === 0;
      panel.hidden = failures.length === 0;
      const pending = quantityPending();
      if (!failures.length && pending) {
        panel.hidden = false;
        status.textContent = w.pending;
        list.hidden = true;
      }
      lock(busy || failures.length > 0 || pending);
      if (focus && failures.length) panel.focus();
      return failures.length === 0;
    }
    let mutatingProperties = false;
    const frozenControls = new Map();
    const locale = document.documentElement.lang.split('-')[0] === 'fr' ? 'fr' : 'en';
    function stableProperties(properties) {
      return JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
    }
    function quantityPending() {
      const controls = [...root.querySelectorAll('[data-quantity-key]')];
      if (controls.some(control => !Number.isSafeInteger(Number(control.value)) ||
        Number(control.value) < 0 || control.value !== control.defaultValue)) return true;
      return protectedItems().some(item => {
        const control = controls.find(el => el.dataset.quantityKey === item.key);
        return !control || Number(control.value) !== item.quantity;
      });
    }
    function freezeControls() {
      form.querySelectorAll('input, select, textarea, button').forEach(control => {
        if (!frozenControls.has(control)) frozenControls.set(control, control.disabled);
        control.disabled = true;
      });
    }
    function thawControls() {
      frozenControls.forEach((wasDisabled, control) => {
        if (control.isConnected) control.disabled = wasDisabled;
      });
      frozenControls.clear();
    }
    async function cartRequest(action = '', body = null) {
      const url = new URL(snapshot.cartUrl.replace(/\/$/, '') +
        (action ? '/' + action : '') + '.js', window.location.origin);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, {
          credentials:'same-origin', cache:'no-store', signal:controller.signal,
          ...(body ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)} : {})
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
        return cart;
      } finally { clearTimeout(timeout); }
    }
    function cartIdentity(cart, helper, managed) {
      const quantities = new Map();
      for (const item of cart.items) {
        const properties = managed.has(String(item.product_id))
          ? helper.localize(item.properties || {}, locale) : item.properties || {};
        const identity = JSON.stringify([item.variant_id,
          item.selling_plan_allocation?.selling_plan?.id || null, stableProperties(properties)]);
        quantities.set(identity, (quantities.get(identity) || 0) + item.quantity);
      }
      return JSON.stringify([...quantities].sort(([a], [b]) => a.localeCompare(b)));
    }
    async function localizeBeforeCheckout(ticket) {
      const helper = window.MagdorCheckoutProperties;
      if (!helper) throw new Error('Missing checkout property helper');
      let cart = await cartRequest();
      if (ticket !== version || !root.isConnected) return true;
      if (quantityPending()) throw new Error('Quantity update pending');
      const rendered = [...root.querySelectorAll('[data-quantity-key]')];
      if (cart.items.length !== rendered.length || cart.items.some(item => {
        const control = rendered.find(el => el.dataset.quantityKey === item.key);
        return !control || Number(control.value) !== item.quantity;
      })) throw new Error('Cart changed; reload before checkout');
      const managed = new Set(protectedItems().map(item => String(item.productId)));
      const pendingItem = current => current.items.find(item =>
        managed.has(String(item.product_id)) &&
        stableProperties(item.properties) !== stableProperties(helper.localize(item.properties || {}, locale)));
      if (!pendingItem(cart)) return false;
      const identity = cartIdentity(cart, helper, managed);
      const maxWrites = cart.items.filter(item => managed.has(String(item.product_id))).length;
      let attemptedPropertyWrite = false;
      mutatingProperties = true;
      busy = true;
      lock(true);
      freezeControls();
      panel.hidden = false;
      status.textContent = w.checking;
      list.hidden = true;
      try {
        const noteControl = form.querySelector('[name="note"]');
        if (noteControl && noteControl.value !== (cart.note || '')) {
          cart = await cartRequest('update', {note:noteControl.value});
          if (cartIdentity(cart, helper, managed) !== identity) throw new Error('Cart changed during note save');
        }
        for (let writes = 0; ; writes++) {
          if (!root.isConnected) throw new Error('Cart view closed');
          const item = pendingItem(cart);
          if (!item) { window.location.reload(); return true; }
          if (writes >= maxWrites) throw new Error('Cart localization did not settle');
          const properties = helper.localize(item.properties || {}, locale);
          attemptedPropertyWrite = true;
          cart = await cartRequest('change', {id:item.key, quantity:item.quantity, properties});
          if (cartIdentity(cart, helper, managed) !== identity) throw new Error('Cart contents changed during localization');
        }
      } catch (error) {
        if (attemptedPropertyWrite) { window.location.reload(); return true; }
        throw error;
      } finally {
        if (!attemptedPropertyWrite) { mutatingProperties = false; thawControls(); }
      }
    }
    async function readCart() {
      const url = new URL(snapshot.cartUrl, window.location.origin);
      url.searchParams.set('section_id', snapshot.sectionId);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
        if (!response.ok) throw new Error('Cart read failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = html.querySelector('[data-mp-cart-data]');
        const next = parseCartSnapshot(data?.textContent || 'null');
        if (!next || next.sectionId !== snapshot.sectionId || !Array.isArray(next.items) || !next.limits) throw new Error('Invalid cart data');
        return next;
      } finally {
        clearTimeout(timeout);
      }
    }
    async function refresh(checkoutButton = null) {
      if (mutatingProperties) return;
      clearTimeout(timer);
      const ticket = ++version;
      busy = true;
      lock(protectedItems().length > 0 || Boolean(checkoutButton));
      if (protectedItems().length) {
        panel.hidden = false;
        status.textContent = w.checking;
        list.hidden = true;
      }
      try {
        const next = await readCart();
        if (ticket !== version || !root.isConnected) return;
        snapshot = next;
        busy = false;
        const valid = show(Boolean(checkoutButton));
        if (!valid || !checkoutButton) return;
        if (quantityPending()) {
          panel.hidden = false;
          status.textContent = w.pending;
          list.hidden = true;
          lock(false);
          panel.focus();
          return;
        }
        busy = true;
        lock(true);
        if (await localizeBeforeCheckout(ticket)) return;
        if (ticket !== version || !root.isConnected) return;
        busy = false;
        if (quantityPending()) {
          panel.hidden = false;
          status.textContent = w.pending;
          list.hidden = true;
          lock(true);
          panel.focus();
          return;
        }
        if (!show(true)) return;
        permitSubmit = true;
        try { form.requestSubmit(checkoutButton); } finally { permitSubmit = false; }
      } catch {
        if (ticket !== version || !root.isConnected) return;
        busy = false;
        if (protectedItems().length) {
          panel.hidden = false;
          status.textContent = w.failed;
          list.hidden = true;
          lock(false);
          if (checkoutButton) panel.focus();
        } else lock(false);
      }
    }
    function schedule() {
      if (mutatingProperties) { freezeControls(); return; }
      if (!root.isConnected) return;
      ++version;
      busy = true;
      lock(protectedItems().length > 0);
      clearTimeout(timer);
      timer = setTimeout(() => refresh(), 400);
    }
    root.addEventListener('click', event => {
      if (mutatingProperties) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (event.target.closest?.('.cart-item__remove')) { schedule(); return; }
      const button = event.target.closest?.('[name="checkout"]');
      if (!button || !root.contains(button) || !protectedItems().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!busy) refresh(button);
    }, true);
    form.addEventListener('submit', event => {
      if (permitSubmit || !protectedItems().length || (event.submitter && event.submitter.name !== 'checkout')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!busy) refresh(event.submitter || buttons()[0]);
    }, true);
    function onQuantityEdit(event) {
      if (!event.target.matches('[data-quantity-key]')) return;
      if (mutatingProperties) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      schedule();
    }
    root.addEventListener('input', onQuantityEdit, true);
    root.addEventListener('change', onQuantityEdit, true);
    const observer = new MutationObserver(records => {
      if (mutatingProperties) { freezeControls(); return; }
      if (records.some(record => record.target.closest?.('[data-cart-table]') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('[data-cart-table]') || node.querySelector('[data-cart-table]'))))) schedule();
      else buttons().forEach(button => { if (protectedItems().length && button.disabled !== lastBlocked) button.disabled = lastBlocked; });
    });
    observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['value','data-quantity-key']});
    controllers.set(root, {refresh:() => refresh(), disconnect:() => { observer.disconnect(); clearTimeout(timer); ++version; }});
    show();
  }
  function boot() {
    if (!window.MagdorCheckoutProperties) return;
    document.querySelectorAll('[data-mp-cart-guard]').forEach(init);
  }
  boot();
  document.addEventListener('magdor:checkout-properties-ready', boot);
  document.addEventListener('DOMContentLoaded', boot, {once:true});
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-mp-cart-guard]').forEach(root => controllers.get(root)?.disconnect());
  });
  window.addEventListener('pageshow', event => {
    boot();
    if (event.persisted) document.querySelectorAll('[data-mp-cart-guard]').forEach(root => controllers.get(root)?.refresh());
  });
  window.addEventListener('focus', () => {
    document.querySelectorAll('[data-mp-cart-guard]').forEach(root => controllers.get(root)?.refresh());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
